export class QueryCostData400Response {
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return QueryCostData400Response.attributeTypeMap;
    }
    constructor() {
    }
}
